"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setJsonData = exports.getJsonData = void 0;
const type_1 = require("../utils/type");
function serializeJson(data) {
    try {
        const jsonString = JSON.stringify(data);
        return new TextEncoder().encode(jsonString);
    }
    catch (e) {
        if ((0, type_1.isError)(e)) {
            e.message = `JsonFeed: ${e.message}`;
        }
        throw e;
    }
}
async function getJsonData(bee, reader) {
    const feedUpdate = await reader.download();
    const retrievedData = await bee.downloadData(feedUpdate.reference);
    return retrievedData.json();
}
exports.getJsonData = getJsonData;
async function setJsonData(bee, writer, postageBatchId, data, options, requestOptions) {
    const serializedData = serializeJson(data);
    const { reference } = await bee.uploadData(postageBatchId, serializedData, options, requestOptions);
    return writer.upload(postageBatchId, reference);
}
exports.setJsonData = setJsonData;
